import { render, staticRenderFns } from "./LeaveManageAdminHeader.vue?vue&type=template&id=c8708242"
import script from "./LeaveManageAdminHeader.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdminHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports